import { Svg } from '@manomano-internal/tamagoshi-icons/esm/SvgOptimizer/Svg';
import { forwardRef } from 'react';

import type { TamagoshiIcon } from '@/core/tamagoshiv2/interfaces';

export const ArrowLeftIcon = forwardRef<SVGSVGElement, TamagoshiIcon>(
  (props, ref) => (
    <Svg
      optimizationId="tama-arrow-left"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <path
        d="M14.71 15.88L10.83 12L14.71 8.11998C15.1 7.72998 15.1 7.09998 14.71 6.70998C14.32 6.31998 13.69 6.31998 13.3 6.70998L8.71001 11.3C8.32001 11.69 8.32001 12.32 8.71001 12.71L13.3 17.3C13.69 17.69 14.32 17.69 14.71 17.3C15.09 16.91 15.1 16.27 14.71 15.88Z"
        fill="currentColor"
      />
    </Svg>
  ),
);
